import React from "react";
import { Link } from "react-router-dom";

// import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Link to="/" className="logo">
          <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
        </Link>
      </div>

      <header className="SideBar-Header">
        <h2 className="SideBar-Header-Name">Abhishek Chakravarty</h2>
        <p className="SideBar-Header-Email">
          <a href="mailto:abhishek.syncro@gmail.com">
            abhishek.syncro@gmail.com
          </a>
        </p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>
        MBA graduate from{" "}
        <a href="https://www.iu.de/" target="_blank" rel="noreferrer">
          IUBH
        </a>{" "}
        and a{" "}
        <a href="https://christuniversity.in/" target="_blank" rel="noreferrer">
          Christ University
        </a>{" "}
        alumnus, I&apos;m a Front-End Developer turned Data Analyst with a
        passion for turning data into impactful insights. During the week, I
        analyze, visualize, and innovate; on weekends, I&apos;m a football
        enthusiast and avid gamer, always up for a challenge—on the field or the
        screen.
      </p>
      {/* <ul className="actions">
        <li>
          {!window.location.pathname.includes("/resume") ? (
            <Link to="/resume" className="button">
              Learn More
            </Link>
          ) : (
            <Link to="/about" className="button">
              About Me
            </Link>
          )}
        </li>
      </ul> */}
    </section>
  </section>
);

export default SideBar;
